import {
	Grid,
	GridColumn, Skeleton, useSnackbar
} from "@livingdesign/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {  useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getService } from "../../axios/axios";
import { RATE_HISTORY } from "../../constants/constants";
import { sortByDate } from "../../helpers/dateTimeUtils";
import DisplayValue from "../TextField/DisplayValue/DisplayValue";
import Timeline from "../Timeline/Timeline";
import TimelineItem from "../Timeline/TimelineItem";
import RateHistoryStyles from './RateHistoryStyles';
import { USER_REQUEST_SERVICE } from "../../constants/baseURLs";
import { amountFormat } from "../../helpers/commonUtils";
import { getErrorMessage } from "../../helpers/utils";
import { displayLocalDate } from "../../helpers/utcUtils";

/**
 * Rate History List
 *
 * @visibleName Rate Changes History Content
 */
const RateHistory = () => {
	const [loading, setLoading] = useState(false);
	const [rateHistoryData, setRateHistoryData] = useState([]);
	const userRequestId = useSelector((state) => state?.user?.userRequestId);
	const classes = RateHistoryStyles();
	const { addSnack } = useSnackbar();
	const { GRID_LABLES, NO_RATE_HISTORY } = RATE_HISTORY;

	useEffect(() => {
		setLoading(true);
		getRateHistories();
	}, []);

	const getRateHistories = () => {
		getService(USER_REQUEST_SERVICE, `/rate-changes/v1/users/${userRequestId}`)
			.then((res) => {
				const data = sortByDate(res?.data?.rateChangeStatusHistories, 'createdTs')
				setRateHistoryData(data);
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				addSnack({
					message: getErrorMessage(error)
				});
			});
	}

	// Format and Display the Rate history Date
	const rateTimelineDate = ({ date }) => {
		const fDate = displayLocalDate(date);
		return <strong className={classes.rateDate}>{fDate}</strong>
	}

	// Format and Display the Narrative text along with Time
	const rateTimelineHeaderDetails = ({ headline, time }) => {
		const fTime = moment(`${time} UTC`.toString()).format('LT');
		return <div className={classes.rateHeaderDetails}>
			<p id="rate-history-heading">{headline}</p>
			<p className={classes.rateTime}>{fTime}</p>
		</div>
	}

	// To Display the grid box
	const rateTimelineItemContent = ({ item }) => {
		const label = item?.practiceAreaCode ? GRID_LABLES.PRACTICE_AREA : GRID_LABLES.MATTER;
		let value;
		if (item?.practiceAreaCode) {
			value = item.practiceAreaCode;
		} else if (item?.matterNumber) {
			value = `${item.matterNumber} | ${item.matterName}`;
		} else {
			value = null;
		}

		return (
			<div className={classes.rateGridContent}>
				<Grid>
					<GridColumn sm="12" md="12" lg="6">
						<div className={classes.contentSpacing16}>
							<DisplayValue
								label={label}
								value={value}
							/>
						</div>
						<div>
							<DisplayValue
								label={GRID_LABLES.PROPOSED_RATE}
								value={item?.proposedWalmartRate ? amountFormat(item?.proposedWalmartRate) : '-'}
							/>
						</div>
					</GridColumn>
					<GridColumn sm="12" md="12" lg="6">
						<div className={classes.contentSpacing16}>
							<DisplayValue
								label={GRID_LABLES.OUTSIDE_ORG_JUSTIFICATION}
								value={item?.outsideOrgJustification ? item?.outsideOrgJustification : '-'}
							/>
						</div>
					</GridColumn>
				</Grid>
			</div>
		);
	};

	// Load Rate history component
	const loadResult = () => {
		return rateHistoryData && rateHistoryData?.length > 0 ?
			<Timeline>
				{rateHistoryData?.map((item) => {
					return (<>
						<TimelineItem>
							{rateTimelineDate({date: item?.createdTs})}
							{rateTimelineHeaderDetails({ headline: item?.narrativeText, time: item?.createdTs})}
							{rateTimelineItemContent({item: item})}
						</TimelineItem>
					</>);
				})
				}
			</Timeline> : <div id="no-rate-history"> {NO_RATE_HISTORY}</div>
	};

	return (
		<div data-testid="rate-history">
			<div className={classes.whiteContainer}>
				{loading ? <Skeleton height="18px" variant="rectangle" /> : loadResult()}
			</div>
		</div>
	)
}

export default RateHistory;
